import { useState } from 'react';
import s from './style.module.scss';
import { Mask } from 'antd-mobile';
import GrtButton from '../GrtButton';
const MobilePreviewImg = ({ src, className }) => {
    const [open, setOpen] = useState(false);
    const download = (e) => {
        e.stopPropagation();
        // window.open(src);
        window.location.href = src;
    };
    return (
        <>
            <Mask destroyOnClose={true} visible={open} onMaskClick={() => setOpen(false)}>
                <div className={s['mobile-modal-img-box']}>
                    <div className={s['modal-img-tool-bar']}>
                        <div onClick={() => setOpen(false)} className={s['close']}>
                            关闭
                        </div>
                        <div className={s['action']} onClick={download}>
                            <GrtButton color="primary"> 下载</GrtButton>
                        </div>
                    </div>
                    <div className={s['modal-preview-img-box']}>
                        <img className={`${s['modal-preview-img']} ${className}`} src={src} />
                    </div>
                </div>
            </Mask>
            <img
                onClick={() => {
                    setOpen(true);
                }}
                className={`${s['preview-img']} ${className}`}
                src={src}
            />
        </>
    );
};

export default MobilePreviewImg;
